// extracted by mini-css-extract-plugin
export var searchHeader = "_46-0";
export var searchHeaderDark = "_46-1";